import { AttendeesResponse as _AttendeesResponse } from './fetchAttendees'
export type AttendeesResponse = _AttendeesResponse
export { default } from './fetchAttendees'
